import {int, unitValue} from "@opendaw/lib-std"

export class Rng {
    #state: int

    constructor(seed: int) {this.#state = (seed | 0) + 0x6D2B79F5}

    next(): unitValue {
        this.#state = (this.#state + 0x6D2B79F5) | 0
        let value = Math.imul(this.#state ^ (this.#state >>> 15), 1 | this.#state)
        value = (value + Math.imul(value ^ (value >>> 7), 61 | value)) ^ value
        return ((value ^ (value >>> 14)) >>> 0) / 4294967296
    }

    nextInt(min: int, max: int): int {return min + Math.floor(this.next() * (max - min + 1))}

    bipolar(): number {return this.next() * 2.0 - 1.0}
}
